import React from 'react';
import PublicNavbar from './PublicNavbar';

const PublicHeader = () => <PublicNavbar />;

export default PublicHeader;
